import React, { Component } from "react"
import { Container, Row, Col } from "reactstrap"
import logo from "../images/icon/nahibu-logo.webp"
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import i18n from 'i18next'

class NahibuFooter extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const t = this.props.t
    const language = i18n.language ? (i18n.language.startsWith("fr") ? "fr" : i18n.language.startsWith("en") ? "en" : 'es') : undefined
    const langSubPath = language === "en" ? "/en" : language === "es" ? "/es" : ""
    return (
      <footer className="footer bg-white my-n5">
        <Container className="my-5 py-5">
          <Row className="d-flex justify-content-between align-items-start">

            {/* Logo nahibu */}
            <Col xs={12} md={3} className="mb-4 mb-md-2 pt-2 d-flex justify-content-center justify-content-md-start align-items-center">
              <img
                alt="Nahibu startup rennaise"
                src={logo}
                height={252}
                width={500}
                style={{ height: "80px", width: "auto" }}
                className="mx-auto mx-md-0"
              />
            </Col>

            {/* Texte nahibu */}
            <Col xs={12} md={6} className="text-center text-md-left pt-3" style={{ color: "#7D7D7D" }}>
              <p className="mb-2 small">{t("footer|Le kit Nahibu n'est pas un dispositif médical.")}</p>
              <p className="mb-2 small">{t("footer|Le produit n'a pas vocation à diagnostiquer et traiter les maladies. Si vous êtes malade, consultez un professionnel de santé.")}</p>
              <p className="mb-2 small">{t("footer|POUR VOTRE SANTÉ, MANGEZ AU MOINS CINQ FRUITS ET LÉGUMES PAR JOUR. www.mangerbouger.fr.")}</p>
            </Col>

            {/* Mentions Légales */}
            <Col xs={12} md={3} className="text-center text-md-end mt-4 mt-md-0">
              <div><p className="footer-title mb-2">{t("footer|Informations légales")}</p></div>
              <div><Link className="light-blue d-block mb-0" to={langSubPath + "/" + t("path|mentions-legales") + "/"}>{t("footer|Mentions légales")}</Link></div>
              <div><Link className="light-blue d-block mb-0" to={langSubPath + "/" + t("path|cgv") + "/"}>{t("footer|CGV")}</Link></div>
              <div><Link className="light-blue d-block mb-0" to={langSubPath + "/" + t("path|politique-cookie") + "/"}>{t("footer|Cookies")}</Link></div>
              <div><Link className="light-blue d-block mb-0" to={langSubPath + "/" + t("path|pudp") + "/"}>{t("footer|Données personnelles")}</Link></div>
              <div><Link className="light-blue d-block mb-0" to={langSubPath + "/" + t("path|contact") + "/"}>{t("footer|Contact")}</Link></div>
            </Col>

          </Row>
        </Container>
      </footer>




    )
  }
}

export default withTranslation()(NahibuFooter)